// Contrôle « nom similaire » à la création d'un contact, partagé par l'écran
// admin (views/people/user-add) et l'écran broker (views/broker/people/user-add).
// Chez le broker, un résultat bloque l'enregistrement ; chez l'admin, c'est un
// avertissement. La recherche elle-même est côté serveur (getSimilarityName,
// person.controller) : trigrammes + nom sans forme juridique ni ponctuation.
//
// Les deux écrans avaient chacun leur copie, avec le même seuil : rien sous
// 6 caractères. « Bht » a été créé 7 fois (6 par un broker le 2025-12-05, 1 par
// l'admin le 2026-09-18), « Roby » 2 fois. Une seule copie désormais : le seuil
// ne peut plus diverger entre admin et broker.
//
// Aussi :
//  - le nom part en query string : dans le chemin, « A/S » ou « 100% » cassaient
//    l'URL ;
//  - les requêtes partent à chaque frappe et peuvent revenir dans le désordre :
//    seule la réponse à la DERNIÈRE frappe est retenue ;
//  - `similarityPending` est vrai tant que le nom affiché n'a pas été contrôlé
//    (réponse pas encore arrivée, ou en échec) : le broker ne peut pas
//    enregistrer entre deux, ni quand le contrôle échoue.
import axios from '@/axios.js'

export const SIMILAR_NAME_MIN_LENGTH = 3

export default {
  data () {
    return {
      similaritiesNamed: [],
      // Nom (tel qu'envoyé au serveur) pour lequel `similaritiesNamed` fait foi.
      similarityCheckedName: null,
      similarityCheckFailed: false,
      similarityRequestSeq: 0
    }
  },
  computed: {
    similarityNameToCheck () {
      const name = ((this.data_local && this.data_local.company_name) || '').trim()
      return name.length >= SIMILAR_NAME_MIN_LENGTH ? name : null
    },
    similarityPending () {
      return this.similarityNameToCheck !== null &&
        this.similarityCheckedName !== this.similarityNameToCheck
    }
  },
  methods: {
    checkTheName () {
      const seq = ++this.similarityRequestSeq
      const name = this.similarityNameToCheck
      this.similarityCheckFailed = false
      if (name === null) {
        this.similaritiesNamed = []
        this.similarityCheckedName = null
        return
      }
      axios.get('/person/getsimilarityname', { params: { name } })
        .then((response) => {
          if (seq !== this.similarityRequestSeq) return
          this.similaritiesNamed = Array.isArray(response.data) ? response.data : []
          this.similarityCheckedName = name
        })
        .catch(() => {
          if (seq !== this.similarityRequestSeq) return
          this.similaritiesNamed = []
          this.similarityCheckedName = null
          this.similarityCheckFailed = true
        })
    }
  },
  mounted () {
    if (this.similarityNameToCheck !== null) this.checkTheName()
  }
}
